import { gql } from '@apollo/client';

export default gql`
  fragment MagentoProductPriceFragment on Magento2_PriceRange {
    minimumPrice {
      regularPrice {
        value
        currency
      }
      finalPrice {
        value
        currency
      }
      discount {
        amountOff
        percentOff
      }
    }
  }

  query PricingPageShopProduct($sku: String!) {
    user {
      id
      isAuthenticated
      country
    }
    magento2 {
      products(filter: { sku: { eq: $sku } }) {
        items {
          __typename
          uid
          ... on Magento2_BundleProduct {
            name
            sku
            image {
              url
              label
            }
            stockStatus
            priceRange {
              ...MagentoProductPriceFragment
            }
          }
          ... on Magento2_VirtualProduct {
            name
            sku
            image {
              url
              label
            }
            stockStatus
            priceRange {
              ...MagentoProductPriceFragment
            }
          }
          ... on Magento2_ConfigurableProduct {
            configurableOptions {
              uid
              label
              position
              attributeCode
              values {
                uid
                label
              }
            }
            variants {
              product {
                uid
                name
                sku
                sdbsId
                isDefaultWithinAllVariants
                image {
                  url
                  label
                }
                stockStatus
                priceRange {
                  ...MagentoProductPriceFragment
                }
                additionalInfo
              }
              attributes {
                uid
                label
                code
                adminLabel
              }
            }
          }
        }
      }
    }
  }
`;
